<template>
  <main class="page">
    <section class="stage" aria-label="ManFun 入口">
      <div class="artframe">
        <img
          class="art"
          :src="backimg"
          width="1024"
          height="1536"
          alt="ManFun 美女艺术背景与入口列表"
        />
        <div class="logo-glow"></div>
        <div class="logo-stars" aria-hidden="true">
          <i class="star" style="left: 6%; top: 70%; --d: -0.2s; --t: 1.2s"></i>
          <i class="star" style="left: 22%; top: 17%; --d: -1s; --t: 1.9s"></i>
          <i
            class="star"
            style="left: 36%; top: 86%; --d: -0.8s; --t: 1.45s"
          ></i>
          <i
            class="star"
            style="left: 52%; top: 42%; --d: -1.6s; --t: 1.35s"
          ></i>
          <i
            class="star"
            style="left: 75%; top: 19%; --d: -0.4s; --t: 1.7s"
          ></i>
          <i
            class="star"
            style="left: 94%; top: 72%; --d: -1.2s; --t: 1.1s"
          ></i>
          <i class="meteor"></i><i class="meteor second"></i>
        </div>
        <div
          class="hotspot chrome"
          rel="noopener noreferrer"
          aria-label="下载谷歌浏览器"
          @click="downloadChrome"
        ></div>
        <div
          class="hotspot edge"
          rel="noopener noreferrer"
          aria-label="下载Edge浏览器"
          @click="downloadEdge"
        ></div>
        <a
          class="hotspot r1"
          href="https://manfun.online/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="线路一"
          ><span class="domain-text" data-domain="r1"></span></a
        ><a
          class="hotspot r2"
          href="https://manfun.online/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="线路二"
          ><span class="domain-text" data-domain="r2"></span></a
        ><a
          class="hotspot r3"
          href="https://manfun.org/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="线路三"
          ><span class="domain-text" data-domain="r3"></span></a
        ><a
          class="hotspot latest"
          href="https://manfun.cc/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="最新地址发布页"
          ><span class="domain-text" data-domain="latest"></span></a
        ><a
          class="hotspot perm"
          href="https://manfun.org/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="永久访问地址"
          ><span class="domain-text" data-domain="perm"></span
        ></a>
      </div>
    </section>
    <footer class="footer">
      <div class="feat">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
        >
          <path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6l8-4z" />
          <path d="M8 12l3 3 5-6" />
        </svg>
        <span class="words"><b>内容丰富</b><small>每日更新</small></span>
      </div>
      <div class="feat">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
        >
          <path d="M3 9l4-6h10l4 6-9 12L3 9zM3 9h18M7 3l5 18 5-18" />
        </svg>
        <span class="words"><b>高清画质</b><small>极致体验</small></span>
      </div>
      <div class="feat">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
        >
          <rect x="4" y="10" width="16" height="12" rx="2" />
          <path d="M8 10V7a4 4 0 0 1 8 0v3" />
        </svg>
        <span class="words"><b>安全加密</b><small>隐私保护</small></span>
      </div>
      <div class="feat">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M12 21s-9-5.5-9-12a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 6.5-9 12-9 12z"
          />
        </svg>
        <span class="words"><b>手机电脑</b><small>完美适配</small></span>
      </div>
    </footer>
  </main>
</template>

<script>
export default {
  data() {
    return {
      LINK_CONFIG: {
        chrome: "https://www.google.com/chrome/",
        edge: "https://www.microsoft.com/edge",
        r1: "https://manfun.online/",
        r2: "https://manfun.online/",
        r3: "https://manfun.org/",
        latest: "https://manfun.cc/",
        perm: "https://manfun.org/",
      },
      backimg: require("@/assets/template.webp"),
    };
  },
  mounted() {
    for (const [key, url] of Object.entries(this.LINK_CONFIG)) {
      const a = document.querySelector("a.hotspot." + key);
      if (!a) continue;
      if (/^https?:\/\//i.test(url)) a.setAttribute("href", url);
      const label = a.querySelector("[data-domain]");
      if (label) {
        try {
          label.textContent = new URL(url).hostname.replace(/^www\./i, "");
        } catch {
          label.textContent = url;
        }
      }
    }
    window.addEventListener("resize", this.fit, { passive: true });
    this.fit();
  },
  methods: {
    fit() {
      const stage = document.querySelector(".stage"),
        frame = document.querySelector(".artframe");
      const h = stage.clientHeight,
        w = stage.clientWidth;
      const scale = Math.max(h / 1324, w / 1024);
      frame.style.width = 1024 * scale + "px";
      frame.style.height = 1536 * scale + "px";
    },

    downloadChrome() {
      const base = process.env.BASE_URL; // 默认 '/'
      // 关键：用 require 让 webpack 处理文件，拿到编译后的真实 URL
      const apkUrl = `${base}download/Google+Chrome_106.0.5249.126_APKPure.apk`;

      const link = document.createElement("a");
      link.href = apkUrl;
      link.download = "Google+Chrome_106.0.5249.126_APKPure.apk"; // 下载后的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    downloadEdge() {
      const base = process.env.BASE_URL; // 默认 '/'
      // 关键：用 require 让 webpack 处理文件，拿到编译后的真实 URL
      const apkUrl = `${base}download/bingchina-arm64-2025120301.apk`;

      const link = document.createElement("a");
      link.href = apkUrl;
      link.download = "bingchina-arm64-2025120301.apk"; // 下载后的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style>
:root {
  --coral: #ff6e6a;
  --footer-height: 140px;
}

* {
  box-sizing: border-box;
}

html {
  background: #191919;
}

body {
  margin: 0;
  background: #191919;
  color: #f8e7e9;
  font-family: Arial, "Microsoft YaHei", sans-serif;
  overflow-x: hidden;
}

a:focus-visible {
  outline: 2px solid #fff;
  outline-offset: -2px;
}

.page {
  width: min(100%, 760px);
  margin: 0 auto;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 54px rgba(0, 0, 0, 0.3);
  background: #191919;
}

.stage {
  position: relative;
  width: 100%;
  height: calc(100dvh - var(--footer-height));
  min-height: 580px;
  overflow: hidden;
  isolation: isolate;
  background: #241619;
}

.artframe {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 150%;
  height: auto;
  aspect-ratio: 1024/1536;
  overflow: visible;
}

.art {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: fill;
}

.hotspot {
  position: absolute;
  z-index: 8;
  display: block;
  border-radius: 8px;
}

.hotspot:hover {
  box-shadow: inset 0 0 20px rgba(255, 110, 106, 0.3);
  outline: 1px solid rgba(255, 110, 106, 0.6);
}

.chrome {
  left: 23.5%;
  top: 42.1%;
  width: 25.7%;
  height: 4.3%;
}

.edge {
  left: 51.7%;
  top: 42.1%;
  width: 25.6%;
  height: 4.3%;
}

.r1 {
  left: 22.6%;
  top: 55%;
  width: 55.4%;
  height: 4.7%;
}

.r2 {
  left: 22.6%;
  top: 59.7%;
  width: 55.4%;
  height: 4.6%;
}

.r3 {
  left: 22.6%;
  top: 64.5%;
  width: 55.4%;
  height: 4.6%;
}

.latest {
  left: 20.2%;
  top: 70.7%;
  width: 60%;
  height: 6.6%;
}

.perm {
  left: 20.2%;
  top: 78.5%;
  width: 60%;
  height: 6.7%;
}

/* Shooting stars fixed to original logo coordinates, not the browser viewport. */
.logo-stars {
  position: absolute;
  z-index: 6;
  left: 26%;
  top: 14.7%;
  width: 53%;
  height: 12.5%;
  pointer-events: none;
  overflow: visible;
}

.star {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: white;
  box-shadow: 0 0 5px 2px #fff, 0 0 14px 5px #ff6e6a,
    0 0 23px 8px rgba(255, 90, 110, 0.65);
  transform: translate(-50%, -50%) scale(0.25);
  animation: twinkle var(--t, 1.6s) ease-in-out infinite alternate;
  animation-delay: var(--d, 0s);
}

.star:before,
.star:after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(90deg, transparent, white, transparent);
  width: 30px;
  height: 1.3px;
}

.star:after {
  transform: translate(-50%, -50%) rotate(90deg);
}

@keyframes twinkle {
  0%,
  15% {
    opacity: 0.1;
    transform: translate(-50%, -50%) scale(0.35);
  }

  65% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.5);
  }

  100% {
    opacity: 0.34;
    transform: translate(-50%, -50%) scale(0.75);
  }
}

.meteor {
  position: absolute;
  z-index: 7;
  left: -30%;
  top: 48%;
  width: 42%;
  height: 3px;
  opacity: 0;
  transform: rotate(-17deg);
  transform-origin: right center;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 125, 145, 0.1),
    rgba(255, 176, 189, 0.8),
    #fff
  );
  filter: drop-shadow(0 0 5px #ff6675) drop-shadow(0 0 9px #ff6e6a);
  animation: fly 3.25s linear infinite;
}

.meteor:after {
  content: "";
  position: absolute;
  right: -4px;
  top: -3px;
  width: 9px;
  height: 9px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 10px 4px white, 0 0 18px 8px #ff6e6a;
}

.meteor.second {
  top: 26%;
  animation-duration: 4.2s;
  animation-delay: -1.75s;
  width: 28%;
  filter: drop-shadow(0 0 6px #ff6e6a);
}

@keyframes fly {
  0%,
  14% {
    left: -50%;
    opacity: 0;
  }

  20% {
    opacity: 1;
  }

  50% {
    opacity: 1;
  }

  68% {
    left: 108%;
    opacity: 0;
  }

  100% {
    left: 108%;
    opacity: 0;
  }
}

.logo-glow {
  position: absolute;
  z-index: 5;
  left: 29%;
  top: 16.4%;
  width: 45%;
  height: 10%;
  pointer-events: none;
  border-radius: 50%;
  background: radial-gradient(
    ellipse,
    rgba(255, 110, 106, 0.27),
    rgba(255, 110, 106, 0.04) 56%,
    transparent 76%
  );
  filter: blur(12px);
  mix-blend-mode: screen;
  animation: glow 2.8s ease-in-out infinite;
}

@keyframes glow {
  0%,
  100% {
    opacity: 0.28;
    transform: scale(0.95);
  }

  50% {
    opacity: 1;
    transform: scale(1.17);
  }
}

.footer {
  flex: 0 0 auto;
  min-height: var(--footer-height);
  padding: 11px 12px calc(12px + env(safe-area-inset-bottom));
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  background: linear-gradient(135deg, #321b25, #191316 48%, #361a27);
  border-top: 1px solid rgba(255, 110, 106, 0.35);
}

.feat {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  background: rgba(255, 110, 106, 0.06);
  border: 1px solid rgba(255, 110, 106, 0.16);
  border-radius: 12px;
  padding: 8px 6px;
  min-width: 0;
}

.feat svg {
  width: 27px;
  height: 27px;
  color: #ff838c;
  flex: none;
  filter: drop-shadow(0 0 6px rgba(255, 110, 106, 0.4));
}

.feat .words {
  font-size: 12px;
  line-height: 1.5;
  white-space: nowrap;
}

.feat b,
.feat small {
  display: block;
  font-weight: 600;
}

.feat small {
  font-weight: 400;
  color: #ebd5d8;
}

/* Desktop: no blown-up image. It uses the image width and scrolls naturally. */
@media (min-width: 650px) {
  .artframe {
    width: 100%;
  }

  :root {
    --footer-height: 100px;
  }

  .page {
    min-height: 0;
  }

  .stage {
    height: auto;
    min-height: 0;
    aspect-ratio: 1024/1324;
  }

  .artframe {
    height: calc(100% * 1536 / 1324);
  }

  .footer {
    grid-template-columns: repeat(4, 1fr);
    gap: 4px;
  }

  .feat {
    gap: 5px;
    padding: 8px 4px;
  }

  .feat svg {
    width: 25px;
    height: 25px;
  }

  .feat .words {
    font-size: 11px;
  }
}

@media (max-width: 360px) {
  :root {
    --footer-height: 132px;
  }

  .feat {
    gap: 6px;
  }

  .feat .words {
    font-size: 11px;
  }

  .feat svg {
    width: 23px;
    height: 23px;
  }

  .footer {
    gap: 5px;
    padding: 8px 6px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .meteor {
    animation-duration: 7s;
  }

  .star {
    animation-duration: 3s;
  }

  .logo-glow {
    animation-duration: 5s;
  }
}

/* Image text was removed; these actual HTML labels replace it and are editable. */
.artframe {
  container-type: inline-size;
}

.hotspot .domain-text {
  position: absolute;
  display: block;
  color: #ff6e7a;
  font-family: Arial, "Microsoft YaHei", sans-serif;
  font-weight: 800;
  font-size: 2.75cqw;
  line-height: 1.15;
  text-align: center;
  white-space: nowrap;
  letter-spacing: -0.035em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.32);
  pointer-events: none;
}

.hotspot.r1 .domain-text,
.hotspot.r2 .domain-text,
.hotspot.r3 .domain-text {
  left: 39.5%;
  width: 39%;
  top: 26%;
}

.hotspot.latest .domain-text,
.hotspot.perm .domain-text {
  left: 30%;
  width: 40%;
  top: 45%;
  font-size: 2.85cqw;
}

@media (min-width: 650px) {
  .hotspot .domain-text {
    font-size: 2.75cqw;
  }
}
</style>
